import React, { Component } from 'react';
import {PropTypes} from 'prop-types';
import style from './style.scss';
import {ShowIf} from 'components/utils';

class SingleFileUploader extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      file: '',
      originName: ''
    }
  }

  handleFileUpload(e) {
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      // file load end
      let data = new FormData();
      data.append(this.props.uploadFieldName, file);

      this.props.fnUpload({}, {
        data: data
      }).then(response => {
        this.setState({
          file: response.data.result.files[this.props.uploadFieldName][0][this.props.responseFieldName],
          originName: response.data.result.files[this.props.uploadFieldName][0][this.props.originFieldName]
        });
        this.props.onUploadCompleted(response.data.result.files[this.props.uploadFieldName][0]);
      }).catch(err => {
        console.log(err);
      });
    };
    reader.readAsDataURL(file);
  }

  removeFile() {
    let callAction = () => {
      this.props.onRemoveFile && this.props.onRemoveFile({
        file: this.state.file
      });

      this.setState({
        file: ''
      });
    }

    if (this.props.confirmRemove && !confirm("Bạn có thực sự muốn xóa file này")) {
      return;
    }

    callAction();
  }

  render() {
    return (
      <div className="upload-img-container">
        <div className='upload-img-wrap-desc'>
          <div className="box-content-file-upload">
            <div className="wrap-input-upload">
              <input type="file" className="form-control-file" aria-describedby="fileHelp" onChange={this.handleFileUpload.bind(this)}/>
              <span className="btn-post-file"><i className="fa fa-cloud-upload"></i>Tải lên báo giá</span>
            </div>
            <ShowIf condition={this.state.file}>
              <div className="image-upload-heading">
                <label className='upload-img-desc'>
                  <span className="remove-file" onClick={this.removeFile.bind(this)}>
                    <i className="fa fa-trash" aria-hidden="true"></i>
                  </span>
                  {this.state.originName}
                </label>
              </div>
            </ShowIf>
          </div>
          <p className="upload-desc">
            <i className="fa fa-info-circle"></i>
            Hỗ trợ định dạng .doc, .pdf với dung lượng không lớn hơn 2MB.
          </p>
        </div>
      </div>
    );
  }

}

SingleFileUploader.propTypes = {
  fnUpload: PropTypes.func.isRequired,
  onUploadCompleted: PropTypes.func,
  uploadFieldName: PropTypes.string,
  responseFieldName: PropTypes.string,
  originFieldName: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['USER','BUSINESS', 'PRODUCT', 'PROMOTION', 'ARTICLE', 'COMPLAIN']),
  confirmRemove: PropTypes.bool
}

SingleFileUploader.defaultProps = {
  uploadFieldName: 'fileUpload',
  responseFieldName: 'name',
  originFieldName: 'originalFilename',
  onUploadCompleted: function(response) {
    console.log(response)
  },
  type: 'BUSINESS',
  confirmRemove: false
}

export default SingleFileUploader;



// WEBPACK FOOTER //
// ./components/uploader/SingleFileUploader.jsx